/** biome-ignore-all lint/correctness/useHookAtTopLevel: Pre-existing */
import { Linking } from "react-native";
import { useLink } from "solito/link";
import { type AnchorExtraProps, isWeb, type SizableTextProps } from "tamagui";
import { previewUrl } from "@medbillai/utils";
import { openMailto } from "../utils/linking";
import { AnchorText } from "./Typography";
export type AnchorProps = SizableTextProps & AnchorExtraProps & {
  isPreviewLink?: boolean;
  title: string;
  href: string;
};
const isInternalLink = (href: string) => {
  return href.startsWith("/") || href.startsWith("#");
};
export const ExternalLink = AnchorText.styleable<AnchorProps>(({
  href,
  target,
  isPreviewLink,
  title,
  children,
  ...props
}) => {
  let linkProps = {};
  if (isWeb) {
    linkProps = {
      href,
      target
    };
  } else if (isPreviewLink) {
    linkProps = useLink({
      href: previewUrl({
        title,
        uri: href
      })
    });
  } else if (isInternalLink(href)) {
    linkProps = useLink({
      href
    });
  } else {
    linkProps = {
      onPress: () => {
        if (href.startsWith("mailto:")) {
          void openMailto(href);
        } else {
          void Linking.openURL(href);
        }
      }
    };
  }
  return <AnchorText {...props} {...linkProps}>
        {children ?? title}
      </AnchorText>;
});